// extracted by mini-css-extract-plugin
export default {"SideItem":"SideItem_SideItem__KukI4"};